// import { Store } from "backend/storage/app.store";
import { appConfig } from "./initializers/config.app";
import _ from "lodash";

export const getAppConfig = () => {
    const initialState = appConfig;
    let storeState = {};
    // if (Store.getState().appConfig) {
    //     storeState = Store.getState().appConfig || {};
    // }
    const result = _.assign({}, initialState, storeState);
    return result;
};
